import PropTypes from "prop-types";
import React from "react";

const SimilarShowsCard = ({ similarShows, median, teamId }) => (
  <div className="d2-card hd-similar-card">
    <div className="hd-similar-header"><h2 className="d2-card-title">Similar past shows</h2></div>
    {similarShows && similarShows.length > 0 ? (
      <>
        <ul className="hd-similar-list">
          {similarShows.map((s) => (
            <li key={s.id} className="hd-similar-row">
              <div>
                <div className="hd-similar-name">
                  {teamId ? <a href={`/teams/${teamId}/e/${s.id}`}>{s.name}</a> : s.name}
                </div>
                <div className="hd-similar-date">{s.date}</div>
              </div>
              <div className="hd-similar-stats">
                <div className="hd-strong">{s.ticketsSold}<span className="hd-muted"> / {s.capacity}</span></div>
                {s.barPerHead != null && <div className="hd-muted">${s.barPerHead.toFixed(2)} bar/head</div>}
              </div>
            </li>
          ))}
        </ul>
        {median && (
          <div className="hd-similar-footer">
            {`Median: ${median.tickets} tickets`}
            {median.barPerHead != null ? ` · $${median.barPerHead.toFixed(2)} bar/head` : ""}
            {` · ${median.soldOut} of ${median.total} sold the floor.`}
          </div>
        )}
      </>
    ) : (
      <div className="hd-empty"><div className="hd-empty-title">No comparable shows yet</div>
        <div className="hd-empty-sub">Confirmed shows at this venue will appear here.</div></div>
    )}
  </div>
);

SimilarShowsCard.propTypes = {
  similarShows: PropTypes.array,
  median: PropTypes.object,
  teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SimilarShowsCard;
